app.service('cartBox', function ($global, console, html, pageConfig) {
	var $self = false;
	var itemsIdsInCart = false;
	var ajax = false;
	var isInit = false;

	function refreshSuccess(response) {
		$self.empty().html(response);
		$self.attr('data-quantity', getCount());
		html.add('load-cart-box');
		itemsIdsInCart = $('#items-in-cart', $self).val().split('|');
		$('#items-in-cart', $self).remove();
		$(document).trigger('cartReady', getBasketConfig());
	}
	function getBasketConfig(config) {
		if (config) {
			return pageConfig.getData('basket')[config];
		} else {
			return pageConfig.getData('basket');
		}
	}

	function getItemProperty(id, prop) {
		return getBasketConfig('items')
			.filter(function (item) {
				return item.id === id;
			})
			.map(function (item) {
				return item[prop];
			})[0];
	}

	function getElements() {
		var items = getBasketConfig('items');
		if (items) {
			return items.map(function (item) {
				return item.id;
			});
		} else {
			return [];
		}
	}

	function getCount() {
		return getBasketConfig('quantity');
	}
	function isOutlet() {
		return getBasketConfig('isOutlet');
	}
	function abortRefresh() {
		if (ajax) {
			ajax.abort();
		}
	}
	function refresh() {
		if ($self.length) {
			abortRefresh();
			ajax = $.ajax({
				url: '/refresh-cart.ltr',
				method: 'POST',
				cache: false,
				success: function (html) {
					refreshSuccess(html);
				},
				error: function () {
					console.log('refreshCartBox ERROR');
				}
			});
		}
	}
	function setEvents() {
	}
	function itemsInCart() {
		return itemsIdsInCart.slice();
	}
	function init() {
		if (!isInit) {
			$self = $('#cart-box');
			$self.attr('data-quantity', getCount());
			setEvents();
			isInit = true;
		}
	}
	$global('cartRefresh', refresh);
	return {
		init,
		abortRefresh,
		refresh,
		getElements,
		getCount,
		itemsInCart,
		isOutlet
	};
});
